interface StatCardProps {
  title: string;
  value: number;
  variant: "primary" | "active" | "blocked";
}

function StatCardUser({ title, value, variant }: StatCardProps) {
  return (
    <div className={`stat-card-user stat-card-user--${variant}`}>
      <span className="stat-card-user__title">{title}</span>
      <span className={`stat-card-user__value stat-value-user--${variant}`}>
        {value}
      </span>
    </div>
  );
}

export default StatCardUser;
